import { EventDateBadge } from "@circle-react/components/Events/shared/EventDateBadge";
import { dateToTimeString } from "@circle-react/helpers/dateTimeHelpers/getLocalizedDate";
import type { EventBookmarkRecord } from "@circle-react/types/Bookmarks";
import { Typography } from "@circleco/compass/components/Typography";

export interface EventProps {
  bookmark: EventBookmarkRecord;
}

export const Event = ({ bookmark }: EventProps) => {
  if (!bookmark.bookmark_record) {
    return <>{}</>;
  }

  const {
    title,
    start_date: startDate,
    starts_at: startsAt,
    ends_at: endsAt,
    time_zone: timeZone,
    time_zone_abbreviations: timeZoneAbbreviations = "",
  } = bookmark.bookmark_record;

  const startTimeString = dateToTimeString(startsAt, timeZone);
  const endTimeString = dateToTimeString(endsAt, timeZone);
  const text = `${startTimeString} - ${endTimeString} ${timeZoneAbbreviations}`;

  return (
    <div className="flex items-center gap-3">
      <EventDateBadge dateString={startDate ?? ""} />
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <Typography
          variant="label-sm"
          className="overflow-anywhere line-clamp-2"
        >
          {title}
        </Typography>
        <Typography variant="caption" color="tertiary">
          {text}
        </Typography>
      </div>
    </div>
  );
};
